import { FC, Fragment, useEffect, useState } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectResult } from 'store/player/playerSelectors';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import PlayerResult from 'components/PlayerResult';
import TextCountdown from 'components/TextCountdown';
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Utilities
import { buildUserName } from 'utilities/Utilities';
// i18next
import { useTranslation } from 'react-i18next';

const QuizGroupLeaderboardPage:FC = () => {
  const { t } = useTranslation('common');
  // State
  const result:any = useAppSelector(selectResult);

  const navigateTo = useNavigateTo();

  const [ startsDate, setStartsDate ] = useState('');
  const [ endsDate, setEndsDate ] = useState('');

  useEffect(() => {
    if ( result && result.quizGroup && result.quizGroup.quizzes ){
      const { startTime, endTime } = result.quizGroup.quizzes.reduce((acc:any, cur:any) => {
        const start = Number(cur.startsDate);
        const end = Number(cur.endsDate);
        acc['startTime'] = !acc.startTime ? start : start < acc.startTime ? start : acc.startTime;
        acc['endTime'] = !acc.endTime ? end : end > acc.endTime ? end : acc.endTime;
        return acc;
      }, {});
      setStartsDate(startTime);
      setEndsDate(endTime);
    }
    // eslint-disable-next-line
  }, []);

  if ( !result || !result.quizGroup ) return null;
  return (
    <Fragment>
      <PublicDevicePlayable />
      <AppBar  />
      <div className="grow p-4 overflow-y-auto">
        <div className="flex items-center mb-4">
          <div style={{ width: 72 }}>
            <Button
              onClick={() => navigateTo('quiz-group')}
              size="small"
            >{t('common.back')}</Button>
          </div>
          <h2 className="grow font-bold text-center text-lg">{t('common.leaderboard')}</h2>
          <div style={{ width: 72 }}></div>
        </div>
        <TextCountdown startsDate={startsDate} endsDate={endsDate} />
        {result.results && result.results.length ? (
          <div className="shadow-neu-content-inner rounded-lg p-2">
            <ul className="rounded">
              {result.results.map((result:any, index:number) => (
                <li
                  key={`leaderboard-item-${index}`}
                  className="flex py-2 px-3 border-b border-gray-100 last:border-none"
                >
                  <div className="flex-1 flex items-center">
                    <span className="font-bold mr-2">{index + 1}.</span>
                    {buildUserName(result)}
                  </div>
                  <div className="font-bold">{result.score}</div>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
      <PlayerResult />
    </Fragment>
  )
}

export default QuizGroupLeaderboardPage;
